<script>
	import { navigate } from "svelte-navigator";

	import model from "../stores/modelStore";

	import Form from "./Form.svelte";
	import FormRow from "./FormRow.svelte";
	import FormColumn from "./FormColumn.svelte";
	import TextButton from "./buttons/TextButton.svelte";
	import PrimaryButton from "./buttons/PrimaryButton.svelte";

	let dialog = null;
	let loading = false;

	const handleSaveAndClose = async () => {
		loading = true;
		$model.saveAndClose = true;

		let response = await model.saveModelAsync("/api/save-and-close");

		if (!response.success) {
			console.log(displayError);
		} else {
			navigate("/Registration/SaveAndClose");
		}
	};
</script>

{#if !$model.surveyComplete}
	<TextButton on:click={() => dialog.showModal()}>Save and Close</TextButton>

	<dialog bind:this={dialog} class="window">
		<Form>
			<div class="content">
				<h3>Save and Close</h3>

				<hr class="primary" />

				<p>
					A valid email address and mobile number are required to return and complete your registration please
					check the details you have provided and confirm these are correct or amend as needed:
				</p>

				<table>
					<tr>
						<td style="width:20%;min-width:80px;">Phone:</td>
						<td style="width:80%;">{$model.contact.phoneNumber}</td>
					</tr>
					<tr>
						<td style="width:20%;min-width:80px;">Email:</td>
						<td style="width:80%;">{$model.contact.emailAddress}</td>
					</tr>
				</table>

				<FormRow>
					<FormColumn class="last">
						<TextButton class="me-3" on:click={() => dialog.close()}>Cancel</TextButton>
						<PrimaryButton {loading} on:click={() => handleSaveAndClose()}>Confirm</PrimaryButton>
					</FormColumn>
				</FormRow>
			</div>
		</Form>
	</dialog>
{/if}

<style>
	.window {
		text-align: left;
		max-width: 100%;
		margin: 2rem auto;
		background: white;
		border-radius: 0.5rem;
		border: 2px solid var(--color-border);
	}

	.content {
		position: relative;
		padding: 1rem;
		overflow: visible;
	}

	@media (min-width: 768px) {
		.window {
			width: 40rem;
		}
	}
</style>
